import { padding, classnames } from '@lumapps/classnames';
import { Message, Text } from '@lumapps/lumx/react';
import * as React from 'react';

import { translate as t } from '../../../translations';
import { MARGIN_FIELDS, PADDING_FIELDS, POSITIVE_SIZE_CHOICES, SIZE_CHOICES } from '../constants';
import { Tab, Tabs } from '../../ui';
import { Measures } from './Measures';

/**
 * Renders a form that edits outer/inner spacing attributes.
 */
export class SpacingSettings extends React.PureComponent {
    constructor(props) {
        super(props);
    }

    render() {
        const { value, name: key, onChange, defaults, state, states, onChangeState, hideMarginTab } = this.props;

        return (
            <Tabs state={state} states={states} onChangeState={onChangeState}>
                {!hideMarginTab && (
                    <Tab id="margin" label={t('STYLE.MARGIN')}>
                        {key === 'main' && (
                            <Message
                                kind="info"
                                className={classnames([padding('horizontal', 'big'), padding('top', 'big')])}
                            >
                                <Text as="span" typography="caption" color="dark" colorVariant="L2">
                                    {t('WIDGET_SETTINGS_RESPONSIVE_SPACING_HELPER')}
                                </Text>
                            </Message>
                        )}
                        <Measures
                            value={value}
                            name={key}
                            onChange={onChange}
                            choices={SIZE_CHOICES}
                            field="margin"
                            fields={MARGIN_FIELDS}
                            defaults={defaults}
                            hasClearChoice
                            suffix="px"
                        />
                    </Tab>
                )}
                <Tab id="padding" label={t('STYLE.PADDING')}>
                    <Measures
                        value={value}
                        name={key}
                        onChange={onChange}
                        choices={POSITIVE_SIZE_CHOICES}
                        field="padding"
                        fields={PADDING_FIELDS}
                        defaults={defaults}
                        hasClearChoice
                        suffix="px"
                    />
                </Tab>
            </Tabs>
        );
    }
}
